// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"807fa622","106":"eb7a3605"}[chunkId] + ".chunk.js";
};